import L from 'leaflet';

const generateIcon = (tint = 'teal', text, expanded) => {

  return new L.divIcon({
    html: `<button type="button" aria-expanded="${expanded.toString()}" class="leaflet-div-icon__button" data-tint="${tint}"><span class="sr-only">${text}</span></button>`
  });
}


export { generateIcon };
